import {
  validateRequired,
  validateArrayRequirement,
  validateConditionalRequired,
  validateName,
  validateEmail,
  validatePhoneNumber,
  validateString,
} from 'utils/validations';

import {
  siteManageVisitorKey,
  siteRequiresPhotoIdKey,
  siteRequiresPhotoKey,
} from 'utils/constants/visitor';

export const contactValidation = {
  subPanelImage: validateRequired(),
  employeeId: validateName(30, false),
  firstName: validateName(30),
  lastName: validateName(30),
  email: validateEmail(true),
  phone: validatePhoneNumber(),
};

export const businessClientValidation = {
  businessClientId: validateName(30, false),
  companyName: validateString(30, true),
};

export const siteBaseValidation = {
  name: validateRequired(),
  timezone: validateRequired(),
  businessClient: validateRequired(),
  locations: validateRequired(),
  address: validateRequired(),
  paths: validateArrayRequirement(3),
  [siteRequiresPhotoIdKey]: validateConditionalRequired({
    conditionKey: siteManageVisitorKey,
    conditionValue: true,
  }),
  [siteRequiresPhotoKey]: validateConditionalRequired({
    conditionKey: siteManageVisitorKey,
    conditionValue: true,
  }),
};
